<template>
  <div style="padding: 20px;">
    <h3>客户信息</h3>
    <br>
    <a-form :form="form" labelAlign="left" >
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="客户姓名">
            <a-input
              placeholder="请输入"
              :maxLength="50"
              v-decorator="['customerName',{rules: [{ required: true, message: '请输入客户姓名' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="电话">
            <a-input
              placeholder="请输入"
              v-decorator="['customerPhone',{
                rules:[{pattern: /^1[34578]\d{9}$/, message: '请输入正确的手机号'}],
                validateTrigger: 'blur'
              }]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="省市区/县">
            <a-cascader 
              :options="cityData" 
              change-on-select 
              placeholder="请选择"
              v-decorator="['region']"
              :fieldNames="{ label: 'label', value: 'label', children: 'children' }"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="详细地址">
            <a-input placeholder="请输入" :maxLength="50" v-decorator="['address']"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="池塘面积(亩)">
            <a-input-number style="width: 100%;" placeholder="请输入" v-decorator="['pondArea']" :min="1" :max="10000000" :precision="2"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="池塘水深(米)">
            <a-input-number style="width: 100%;" placeholder="请输入" v-decorator="['pondWaterDepth']" :min="1" :max="1000" :precision="2"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="水源情况">
            <a-radio-group v-decorator="['waterCondition']" >
              <a-radio v-for="el in waterConditionList" :key="el.id" :value="el.name">
                {{ el.name }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="增氧机/水车配置(台)">
            <a-input-number style="width: 100%;" placeholder="请输入" v-decorator="['aeratorWaterWheelNum']" :min="1" :max="100000" :precision="0"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="增氧机/水车功率(kw/台)">
            <a-input-number style="width: 100%;" placeholder="请输入" v-decorator="['aeratorWaterWheelPower']" :min="1" :max="10000" :precision="2"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="投饵机（台）">
            <a-input-number style="width: 100%;" placeholder="请输入" v-decorator="['baitThrower']" :min="1" :max="100000" :precision="0"/>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="备注">
            <a-input placeholder="请输入" v-decorator="['remark']" :maxLength="50"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="业务员">
            <a-input
              placeholder="请输入"
              :maxLength="50"
              v-decorator="['salesManName',{rules: [{ required: true, message: '请输入业务员' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="所属工厂">
            <a-select 
              placeholder="请选择"
              @change="handleFactoryChange"
              v-decorator="['factoryName',{
                rules:[{required: true, message: '请选择所属工厂'}],
                initialValue:selectFactory
              }]"
            >
              <a-select-option v-for="el in factoryList" :key="el.factoryId" :value="el.factoryName">
                {{ el.factoryName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="聚落/片区">{{settlementName}}</a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import {cityData} from '../../Common/region'
import {waterConditionList} from './Lists'
import { mapMutations } from 'vuex';
export default {
  props:['customerInfo'],
  data(){
    return{
      form: this.$form.createForm(this),
      cityData,
      waterConditionList,
      factoryList:[],
      settlementName:'',
      selectFactory:undefined
    }
  },
  watch:{
    customerInfo(){
      this.form.setFieldsValue(this.customerInfo)
      this.factoryGet()
    },
  },
  mounted(){
    this.form.setFieldsValue(this.customerInfo)
    this.factoryGet()
  },
  
  methods:{
    ...mapMutations('empirical',['setState']),
    // 获取当前选择工厂信息
    handleFactoryChange(value) {
      let factoryAnimalList = this.factoryList.find(item => item.factoryName == value)?.factoryAnimalList;
      let factoryId = this.factoryList.find(item => item.factoryName == value)?.factoryId;
      this.selectFactory = value
      this.settlementName = this.factoryList.find(item => item.factoryName == value)?.settlementName;
      let settlementId = this.factoryList.find(item => item.factoryName == value)?.settlementId;
      this.$emit('setFactory',  {selectFactory:this.selectFactory,settlementId,settlementName:this.settlementName,factoryId})
      if(!factoryAnimalList?.find(item => item.animalName =='3 水产')) {
        this.setState({currentFactory: value,hasFish: false})
        this.$warning({
          title: `暂无工厂“${value}”的水产线路填报权限`,
          content: '请确认工厂或负责线路是否有误',
        });
      }else{
        this.setState({currentFactory: null,hasFish: true})
      }
    },
    // 获取工厂列表
    async factoryGet() {
      let userId = window.localStorage.getItem('staffId')
      const res = await this.$http.get("/sat-collect/auth/permissions", { params:{userId} })
      let { success, data } = res;
      if (success) {
        let { factoryAndSettles} = data;
        this.factoryList = factoryAndSettles || [];
        if(!this.$route.query.copyId && !this.customerInfo.factoryName) this.handleFactoryChange(window.localStorage.getItem('factoryName'))
        else if(this.customerInfo.factoryName) this.handleFactoryChange(this.customerInfo.factoryName)
      }
    },
  }
}
</script>

<style>

</style>